// export const projects = [
//   {
//     id: 1,
//     title: "NADRA OneApp",
//     subtitle: "Unified Digital Identity Platform",
//     description:
//       "Pakistan's unified digital identity platform integrating 10+ critical services with biometric authentication and LDAP security. Designed both the Java Spring Boot microservices backend and React frontend architecture.",
//     detailedDescription: [
//       "Led the development of Pakistan's unified digital identity platform",
//       "Integrated 10+ critical services including Digital ID/Vault, e-Visa, Biometric Verification",
//       "Implemented biometric authentication (ICAO-standard photo/iris) and LDAP security",
//       "New microservices architecture enabling citizens to access all NADRA services through one secure platform",
//     ],
//     technologies: ["React", "Spring Boot", "Microservices", "Oracle"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [
//       {
//         title: "NADRA Self Service KIOSK System",
//         description:
//           "Built a self-service kiosk using React + Spring Boot + Oracle that processes ID renewals, biometric updates and payments.",
//         technologies: [
//           "React",
//           "Spring Boot",
//           "Oracle",
//           "Biometric Integration",
//         ],
//       },
//       {
//         title: "NADRA Queue Management System",
//         description:
//           "Designed and built a smart ticketing system from scratch using React and Springboot with online booking feature.",
//         technologies: ["React", "Spring Boot", "Microservices"],
//       },
//     ],
//   },
//   {
//     id: 2,
//     title: "NADRA OneApp",
//     subtitle: "Unified Digital Identity Platform",
//     description:
//       "Pakistan's unified digital identity platform integrating 10+ critical services with biometric authentication and LDAP security. Designed both the Java Spring Boot microservices backend and React frontend architecture.",
//     detailedDescription: [
//       "Led the development of Pakistan's unified digital identity platform",
//       "Integrated 10+ critical services including Digital ID/Vault, e-Visa, Biometric Verification",
//       "Implemented biometric authentication (ICAO-standard photo/iris) and LDAP security",
//       "New microservices architecture enabling citizens to access all NADRA services through one secure platform",
//     ],
//     technologies: ["React", "Spring Boot", "Microservices", "Oracle"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [
//       {
//         title: "NADRA Self Service KIOSK System",
//         description:
//           "Built a self-service kiosk using React + Spring Boot + Oracle that processes ID renewals, biometric updates and payments.",
//         technologies: [
//           "React",
//           "Spring Boot",
//           "Oracle",
//           "Biometric Integration",
//         ],
//       },
//       {
//         title: "NADRA Queue Management System",
//         description:
//           "Designed and built a smart ticketing system from scratch using React and Springboot with online booking feature.",
//         technologies: ["React", "Spring Boot", "Microservices"],
//       },
//     ],
//   },
//   {
//     id: 3,
//     title: "NADRA OneApp",
//     subtitle: "Unified Digital Identity Platform",
//     description:
//       "Pakistan's unified digital identity platform integrating 10+ critical services with biometric authentication and LDAP security. Designed both the Java Spring Boot microservices backend and React frontend architecture.",
//     detailedDescription: [
//       "Led the development of Pakistan's unified digital identity platform",
//       "Integrated 10+ critical services including Digital ID/Vault, e-Visa, Biometric Verification",
//       "Implemented biometric authentication (ICAO-standard photo/iris) and LDAP security",
//       "New microservices architecture enabling citizens to access all NADRA services through one secure platform",
//     ],
//     technologies: ["React", "Spring Boot", "Microservices", "Oracle"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [
//       {
//         title: "NADRA Self Service KIOSK System",
//         description:
//           "Built a self-service kiosk using React + Spring Boot + Oracle that processes ID renewals, biometric updates and payments.",
//         technologies: [
//           "React",
//           "Spring Boot",
//           "Oracle",
//           "Biometric Integration",
//         ],
//       },
//       {
//         title: "NADRA Queue Management System",
//         description:
//           "Designed and built a smart ticketing system from scratch using React and Springboot with online booking feature.",
//         technologies: ["React", "Spring Boot", "Microservices"],
//       },
//     ],
//   },
//   {
//     id: 4,
//     title: "NADRA OneApp",
//     subtitle: "Unified Digital Identity Platform",
//     description:
//       "Pakistan's unified digital identity platform integrating 10+ critical services with biometric authentication and LDAP security. Designed both the Java Spring Boot microservices backend and React frontend architecture.",
//     detailedDescription: [
//       "Led the development of Pakistan's unified digital identity platform",
//       "Integrated 10+ critical services including Digital ID/Vault, e-Visa, Biometric Verification",
//       "Implemented biometric authentication (ICAO-standard photo/iris) and LDAP security",
//       "New microservices architecture enabling citizens to access all NADRA services through one secure platform",
//     ],
//     technologies: ["React", "Spring Boot", "Microservices", "Oracle"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [
//       {
//         title: "NADRA Self Service KIOSK System",
//         description:
//           "Built a self-service kiosk using React + Spring Boot + Oracle that processes ID renewals, biometric updates and payments.",
//         technologies: [
//           "React",
//           "Spring Boot",
//           "Oracle",
//           "Biometric Integration",
//         ],
//       },
//       {
//         title: "NADRA Queue Management System",
//         description:
//           "Designed and built a smart ticketing system from scratch using React and Springboot with online booking feature.",
//         technologies: ["React", "Spring Boot", "Microservices"],
//       },
//     ],
//   },
//   {
//     id: 5,
//     title: "NADRA OneApp",
//     subtitle: "Unified Digital Identity Platform",
//     description:
//       "Pakistan's unified digital identity platform integrating 10+ critical services with biometric authentication and LDAP security. Designed both the Java Spring Boot microservices backend and React frontend architecture.",
//     detailedDescription: [
//       "Led the development of Pakistan's unified digital identity platform",
//       "Integrated 10+ critical services including Digital ID/Vault, e-Visa, Biometric Verification",
//       "Implemented biometric authentication (ICAO-standard photo/iris) and LDAP security",
//       "New microservices architecture enabling citizens to access all NADRA services through one secure platform",
//     ],
//     technologies: ["React", "Spring Boot", "Microservices", "Oracle"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [
//       {
//         title: "NADRA Self Service KIOSK System",
//         description:
//           "Built a self-service kiosk using React + Spring Boot + Oracle that processes ID renewals, biometric updates and payments.",
//         technologies: [
//           "React",
//           "Spring Boot",
//           "Oracle",
//           "Biometric Integration",
//         ],
//       },
//       {
//         title: "NADRA Queue Management System",
//         description:
//           "Designed and built a smart ticketing system from scratch using React and Springboot with online booking feature.",
//         technologies: ["React", "Spring Boot", "Microservices"],
//       },
//     ],
//   },
//   {
//     id: 6,
//     title: "NADRA OneApp",
//     subtitle: "Unified Digital Identity Platform",
//     description:
//       "Pakistan's unified digital identity platform integrating 10+ critical services with biometric authentication and LDAP security. Designed both the Java Spring Boot microservices backend and React frontend architecture.",
//     detailedDescription: [
//       "Led the development of Pakistan's unified digital identity platform",
//       "Integrated 10+ critical services including Digital ID/Vault, e-Visa, Biometric Verification",
//       "Implemented biometric authentication (ICAO-standard photo/iris) and LDAP security",
//       "New microservices architecture enabling citizens to access all NADRA services through one secure platform",
//     ],
//     technologies: ["React", "Spring Boot", "Microservices", "Oracle"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [
//       {
//         title: "NADRA Self Service KIOSK System",
//         description:
//           "Built a self-service kiosk using React + Spring Boot + Oracle that processes ID renewals, biometric updates and payments.",
//         technologies: [
//           "React",
//           "Spring Boot",
//           "Oracle",
//           "Biometric Integration",
//         ],
//       },
//       {
//         title: "NADRA Queue Management System",
//         description:
//           "Designed and built a smart ticketing system from scratch using React and Springboot with online booking feature.",
//         technologies: ["React", "Spring Boot", "Microservices"],
//       },
//     ],
//   },
//   {
//     id: 7,
//     title: "NADRA OneApp",
//     subtitle: "Unified Digital Identity Platform",
//     description:
//       "Pakistan's unified digital identity platform integrating 10+ critical services with biometric authentication and LDAP security. Designed both the Java Spring Boot microservices backend and React frontend architecture.",
//     detailedDescription: [
//       "Led the development of Pakistan's unified digital identity platform",
//       "Integrated 10+ critical services including Digital ID/Vault, e-Visa, Biometric Verification",
//       "Implemented biometric authentication (ICAO-standard photo/iris) and LDAP security",
//       "New microservices architecture enabling citizens to access all NADRA services through one secure platform",
//     ],
//     technologies: ["React", "Spring Boot", "Microservices", "Oracle"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [
//       {
//         title: "NADRA Self Service KIOSK System",
//         description:
//           "Built a self-service kiosk using React + Spring Boot + Oracle that processes ID renewals, biometric updates and payments.",
//         technologies: [
//           "React",
//           "Spring Boot",
//           "Oracle",
//           "Biometric Integration",
//         ],
//       },
//       {
//         title: "NADRA Queue Management System",
//         description:
//           "Designed and built a smart ticketing system from scratch using React and Springboot with online booking feature.",
//         technologies: ["React", "Spring Boot", "Microservices"],
//       },
//     ],
//   },
//   {
//     id: 8,
//     title: "NADRA OneApp",
//     subtitle: "Unified Digital Identity Platform",
//     description:
//       "Pakistan's unified digital identity platform integrating 10+ critical services with biometric authentication and LDAP security. Designed both the Java Spring Boot microservices backend and React frontend architecture.",
//     detailedDescription: [
//       "Led the development of Pakistan's unified digital identity platform",
//       "Integrated 10+ critical services including Digital ID/Vault, e-Visa, Biometric Verification",
//       "Implemented biometric authentication (ICAO-standard photo/iris) and LDAP security",
//       "New microservices architecture enabling citizens to access all NADRA services through one secure platform",
//     ],
//     technologies: ["React", "Spring Boot", "Microservices", "Oracle"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [
//       {
//         title: "NADRA Self Service KIOSK System",
//         description:
//           "Built a self-service kiosk using React + Spring Boot + Oracle that processes ID renewals, biometric updates and payments.",
//         technologies: [
//           "React",
//           "Spring Boot",
//           "Oracle",
//           "Biometric Integration",
//         ],
//       },
//       {
//         title: "NADRA Queue Management System",
//         description:
//           "Designed and built a smart ticketing system from scratch using React and Springboot with online booking feature.",
//         technologies: ["React", "Spring Boot", "Microservices"],
//       },
//     ],
//   },
//   // Add all other projects in the same format
// ];
// export const projectTypes = [
//   {
//     id: "fullStack",
//     label: "Full Stack Development",
//   },
//   {
//     id: "frontEnd",
//     label: "Front End Development",
//   },
//   {
//     id: "backEnd",
//     label: "Back End Development",
//   },
//   {
//     id: "mobileApp",
//     label: "Mobile App Development",
//   },
// ];

// export const projects = [
//   {
//     id: 1,
//     title: "NADRA OneApp",
//     subtitle: "Unified Digital Identity Platform",
//     description:
//       "Pakistan's unified digital identity platform integrating 10+ critical services with biometric authentication and LDAP security. Designed both the Java Spring Boot microservices backend and React frontend architecture.",
//     detailedDescription: [
//       "Led the development of Pakistan's unified digital identity platform",
//       "Integrated 10+ critical services including Digital ID/Vault, e-Visa, Biometric Verification, Succession Certificates, Arms License, etc.",
//       "Implemented biometric authentication (ICAO-standard photo/iris) and LDAP security",
//       "Used microservices architecture for secure and scalable integration of services",
//     ],
//     technologies: [
//       "Java",
//       "Spring Boot",
//       "React",
//       "Next.js",
//       "Oracle",
//       "Microservices",
//       "LDAP",
//       "Biometric",
//     ],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [
//       {
//         title: "NADRA Self Service KIOSK System",
//         description:
//           "Self-service kiosk built with React and Spring Boot to handle ID renewals, biometric updates, and secure payments integrated with ICAO cameras and POS systems.",
//         technologies: ["React", "Spring Boot", "Oracle", "Biometric", "POS"],
//       },
//       {
//         title: "NADRA Queue Management System",
//         description:
//           "Developed a ticketing and online appointment system using React and Spring Boot with microservices for reduced wait times.",
//         technologies: ["React", "Spring Boot", "Microservices"],
//       },
//       {
//         title: "Somalian National ID System",
//         description:
//           "Created a digital ID system using React and Spring Boot, automating citizen registration to ID card printing with RabbitMQ for communication.",
//         technologies: ["React", "Spring Boot", "RabbitMQ"],
//       },
//       {
//         title: "Decision Support System",
//         description:
//           "Analytics platform built with Spring Boot and React to improve NADRA service delivery through data-driven insights.",
//         technologies: ["Spring Boot", "React"],
//       },
//     ],
//   },
//   {
//     id: 2,
//     title: "Inspire Medical Social Platform",
//     subtitle: "Healthcare Community Network",
//     description:
//       "Medical social platform for patients and doctors to share journals and join communities, handling 10M+ monthly users. Developed using Angular and optimized with unit testing.",
//     detailedDescription: [
//       "Built dynamic forms and journals for user interactions",
//       "Ensured frontend performance and responsiveness",
//       "Wrote Jasmine-based unit tests to maintain code quality",
//     ],
//     technologies: ["Angular", "Jasmine"],
//     projectType: "frontend",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 3,
//     title: "Pulse Employee Management System",
//     subtitle: "HR and Employee Portal",
//     description:
//       "Full-stack HR platform for leave, attendance, and employee engagement using Angular, Node.js, and PostgreSQL.",
//     detailedDescription: [
//       "Developed REST APIs for leave and attendance management",
//       "Built UI components and maintained client collaboration",
//       "Integrated PostgreSQL for backend data operations",
//     ],
//     technologies: ["Angular", "Node.js", "PostgreSQL"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 4,
//     title: "RapidFlow",
//     subtitle: "Workflow Automation Platform",
//     description:
//       "Workflow automation platform to streamline business processes through digital workflows using Angular and Node.js.",
//     detailedDescription: [
//       "Built 20+ REST APIs and optimized backend queries by 50%",
//       "Reduced frontend build size using lazy loading",
//       "Fixed memory leaks and deployed scalable architecture on AWS",
//     ],
//     technologies: ["Angular", "Node.js", "PostgreSQL", "AWS"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 5,
//     title: "Shahadh",
//     subtitle: "Certificate Management System",
//     description:
//       "Digital certificate platform allowing organizations to generate and store secure certificates using Angular and Node.js.",
//     detailedDescription: [
//       "Automated certificate creation and distribution workflows",
//       "Used Jasmine for Angular unit testing",
//       "Backend in Node.js with MongoDB",
//     ],
//     technologies: ["Angular", "Node.js", "MongoDB", "Jasmine"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 6,
//     title: "FutureHub",
//     subtitle: "NGO E-Commerce Platform",
//     description:
//       "Donation-based e-commerce platform enabling secure contributions via product purchases. Built with Angular and Node.js.",
//     detailedDescription: [
//       "Integrated Neonomics payment API",
//       "Optimized frontend/backend performance",
//       "Built scalable full-stack architecture",
//     ],
//     technologies: ["Angular", "Node.js", "PostgreSQL"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 7,
//     title: "Sidra Portal",
//     subtitle: "E-Health Management System",
//     description:
//       "Healthcare system for managing appointments, medicine, and patient records. Built with Angular frontend and Spring Boot backend.",
//     detailedDescription: [
//       "Created MIS dashboards, live location tracking, and reports",
//       "Used MySQL for healthcare data",
//       "Enabled certificate generation and appointment handling",
//     ],
//     technologies: ["Angular", "Spring Boot", "MySQL"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 8,
//     title: "Pronto",
//     subtitle: "AI-Powered Video Editor",
//     description:
//       "AI-driven promotional video editor allowing users to create customizable videos with voiceovers, text, and music using Angular.",
//     detailedDescription: [
//       "Developed frontend UI in Angular",
//       "Implemented WebSocket for real-time updates",
//       "Integrated REST APIs and OAuth login for secure access",
//     ],
//     technologies: ["Angular", "WebSockets", "OAuth", "REST API"],
//     projectType: "frontend",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 9,
//     title: "Dowwak",
//     subtitle: "Hospital Management System",
//     description:
//       "Backend system for hospital operations including appointments, medicine delivery, and analytics dashboards using Node.js.",
//     detailedDescription: [
//       "Created Node.js APIs for appointments and staff management",
//       "Collaborated with frontend Angular team",
//       "Built manager dashboards for analytics",
//     ],
//     technologies: ["Node.js", "PostgreSQL"],
//     projectType: "backend",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 10,
//     title: "CAFOO",
//     subtitle: "Event & Food Delivery Platform",
//     description:
//       "Full-stack web app for restaurants and event vendors to register and offer services. Built using Angular and Node.js.",
//     detailedDescription: [
//       "Developed user dashboards and event booking features",
//       "Built and optimized RESTful APIs",
//       "Used PostgreSQL for backend data and JIRA for Agile management",
//     ],
//     technologies: ["Angular", "Node.js", "PostgreSQL", "JIRA"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [],
//   },
// ];
// export const projects = [
//   {
//     id: 1,
//     title: "NADRA OneApp",
//     subtitle: "Unified Digital Identity Platform",
//     description:
//       "A centralized platform integrating 10+ national services (e‑Visa, biometric verification, passport apps, etc.) into a secure citizen portal.",
//     detailedDescription: [
//       "Led architecture and development of microservices-based backend (Spring Boot) and frontend (React/Angular/Next.js)",
//       "Designed and built secure REST APIs with LDAP and ICAO-standard biometric authentication",
//       "Integrated services including Digital ID/Vault, e‑Visa, Power of Attorney, Succession Certificates, Arms License, Pensioner Verification",
//       "Collaborated with DevOps, QA, and design teams to ensure production readiness and UX quality",
//       "Reviewed code and mentored frontend/backend developers on best practices",
//     ],
//     technologies: [
//       "Java",
//       "Spring Boot",
//       "React",
//       "Next.js",
//       "Oracle",
//       "LDAP",
//       "JWT",
//       "Biometric",
//     ],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [
//       {
//         title: "NADRA Self Service KIOSK System",
//         description:
//           "Touch-enabled kiosk for ID renewals, biometric updates, and secure payments.",
//         detailedDescription: [
//           "Built complete frontend (React) and backend (Spring Boot + Oracle)",
//           "Integrated ICAO cameras, biometric scanners, and POS payment systems",
//           "Conducted end-to-end QA testing, fixing critical bugs before launch",
//         ],
//         technologies: ["React", "Spring Boot", "Oracle", "POS", "Biometric"],
//       },
//       {
//         title: "NADRA Queue Management & Appointment System",
//         description:
//           "Real-time ticketing and appointment booking platform to reduce office wait times.",
//         detailedDescription: [
//           "Developed token management microservice in Spring Boot",
//           "Built React UI with live updates using WebSockets",
//           "Integrated appointment scheduling, SMS notifications, and RabbitMQ messaging",
//         ],
//         technologies: [
//           "React",
//           "Spring Boot",
//           "Microservices",
//           "RabbitMQ",
//           "WebSockets",
//         ],
//       },
//       {
//         title: "Somalian National ID System",
//         description:
//           "A national ID workflow system including registration and ID card printing.",
//         detailedDescription: [
//           "Developed backend workflows in Spring Boot and frontend in React",
//           "Automated citizen registration to ID issuance processes",
//           "Integrated RabbitMQ for inter-service communication handling",
//         ],
//         technologies: ["React", "Spring Boot", "RabbitMQ", "Microservices"],
//       },
//       {
//         title: "Decision Support System",
//         description:
//           "Analytics platform to optimize NADRA operations via data-driven insights.",
//         detailedDescription: [
//           "Built analytics dashboards using Spring Boot backend and React frontend",
//           "Processed operational data to detect trends and bottlenecks",
//           "Enabled data-driven resource allocation and performance tracking",
//         ],
//         technologies: ["Spring Boot", "React", "Analytics"],
//       },
//     ],
//   },
//   {
//     id: 2,
//     title: "RapidFlow",
//     subtitle: "Workflow Automation Platform",
//     description:
//       "A drag-and-drop workflow automation platform helping businesses automate processes.",
//     detailedDescription: [
//       "Developed 20+ REST APIs in Node.js to support dynamic workflow actions",
//       "Optimized PostgreSQL performance with indexing, reducing query times by ~50%",
//       "Reduced Angular frontend build size to ~4 MB using lazy loading",
//       "Detected and fixed memory leaks and performance bottlenecks",
//       "Collaborated with Dubai-based remote team and deployed scalable solution on AWS",
//     ],
//     technologies: ["Angular", "Node.js", "PostgreSQL", "AWS", "JWT", "OKTA"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 3,
//     title: "Shahadh",
//     subtitle: "Certificate Management System",
//     description:
//       "A platform for creating, distributing, and verifying digital certificates securely.",
//     detailedDescription: [
//       "Built backend services in Node.js for certificate generation, PDF export, and QR code validation",
//       "Created responsive frontend in Angular, writing unit tests with Jasmine",
//       "Implemented JWT-based authentication and modeled MongoDB schema for storage",
//       "Tracked and fixed bugs to reduce QA feedback loop by ~40%",
//     ],
//     technologies: ["Angular", "Node.js", "MongoDB", "JWT", "Jasmine"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 4,
//     title: "Inspire Medical Social Platform",
//     subtitle: "Healthcare Community Network",
//     description:
//       "A medical social platform for patients and doctors to share content and join support communities.",
//     detailedDescription: [
//       "Built Angular UI components for dynamic forms and journal management",
//       "Optimized performance to support 10M+ monthly users",
//       "Developed backend APIs using Node.js and PostgreSQL",
//       "Wrote Jasmine tests and participated in sprint planning with product team",
//       "Collaborated with UX team to implement performance enhancements",
//     ],
//     technologies: [
//       "Angular",
//       "Node.js",
//       "PostgreSQL",
//       "AWS",
//       "Jasmine",
//       "JIRA",
//     ],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 5,
//     title: "Pulse Employee Management System",
//     subtitle: "HR and Employee Engagement Portal",
//     description:
//       "A full-stack HR portal for attendance, leave management, and employee social interaction.",
//     detailedDescription: [
//       "Developed REST APIs in Node.js/Express for attendance, leave, and payroll workflows",
//       "Built Angular frontend components and integrated PostgreSQL backend",
//       "Coordinated daily with clients to align feature delivery",
//       "Added JWT authentication and user role management",
//       "Ensured system performance and reliability through testing and code reviews",
//     ],
//     technologies: ["Angular", "Node.js", "Express", "PostgreSQL", "JWT"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 6,
//     title: "Dowwak",
//     subtitle: "Hospital Management System",
//     description:
//       "A backend system for managing hospital operations including appointments, record-keeping, and medical logistics.",
//     detailedDescription: [
//       "Developed Node.js backend APIs for patient registration, appointment scheduling, and medicine delivery",
//       "Collaborated with Angular frontend team to design data flows and services",
//       "Created dashboards for managers to track staff performance and key hospital metrics",
//       "Optimized database design and queries using PostgreSQL",
//       "Ensured secure REST endpoints and data validation",
//     ],
//     technologies: ["Node.js", "Express", "PostgreSQL", "REST API"],
//     projectType: "backend",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 7,
//     title: "CAFOO",
//     subtitle: "Event & Food Delivery Platform",
//     description:
//       "A full‑stack web application for restaurants and vendors to register and take orders for events.",
//     detailedDescription: [
//       "Built Angular frontend dashboards for event bookings, menus, and vendor signup",
//       "Developed RESTful APIs in Node.js with PostgreSQL backend",
//       "Optimized database schema and query performance",
//       "Managed tasks and sprints using Agile methodologies with JIRA",
//       "Integrated authentication and vendor/customer flows securely",
//     ],
//     technologies: ["Angular", "Node.js", "PostgreSQL", "REST API", "JIRA"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 8,
//     title: "FutureHub",
//     subtitle: "NGO E‑Commerce & Donation Platform",
//     description:
//       "A donation-driven e-commerce platform enabling secure contributions through product purchases.",
//     detailedDescription: [
//       "Developed Angular frontend user flows and product browsing",
//       "Implemented Node.js backend APIs and PostgreSQL database",
//       "Integrated Neonomics payment gateway for secure transactions",
//       "Optimized frontend and backend for performance and reliability",
//       "Structured agile delivery and sprint planning using JIRA",
//     ],
//     technologies: [
//       "Angular",
//       "Node.js",
//       "PostgreSQL",
//       "Neonomics",
//       "REST API",
//       "JIRA",
//     ],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 9,
//     title: "Sidra Portal",
//     subtitle: "E‑Health Management System",
//     description:
//       "An integrated healthcare platform for patient appointments, medicine delivery, and medical dashboards.",
//     detailedDescription: [
//       "Built Angular frontend for appointment booking, medicine orders, and patient profile management",
//       "Developed Spring Boot backend for MIS dashboards, reporting, and live tracking",
//       "Implemented MySQL database for secure health data storage",
//       "Enabled certificate generation for prescriptions and visits",
//       "Coordinated with stakeholders for requirement gathering and iterative delivery",
//     ],
//     technologies: ["Angular", "Spring Boot", "MySQL", "REST API"],
//     projectType: "fullStack",
//     hasDetails: true,
//     subProjects: [],
//   },
//   {
//     id: 10,
//     title: "Pronto",
//     subtitle: "AI‑Powered Video Editor",
//     description:
//       "A video editing tool that uses AI to produce 6–60s promotional videos with voiceovers, music, and text.",
//     detailedDescription: [
//       "Built Angular-based frontend UI with real-time editing workflows",
//       "Implemented WebSocket communication for live progress updates",
//       "Integrated REST APIs and OAuth for secure user access and social login",
//       "Worked closely with AI team to connect and manage edit pipelines",
//       "Optimized user experience and error handling",
//     ],
//     technologies: ["Angular", "WebSockets", "OAuth", "REST API"],
//     projectType: "frontend",
//     hasDetails: true,
//     subProjects: [],
//   },
// ];

export const projects = [
  {
    id: 21,
    title: "NADRA OneApp",
    subtitle: "Unified Digital Identity Platform",
    description:
      "Pakistan's integrated digital identity platform consolidating 10+ critical citizen services with biometric authentication.",
    detailedDescription: [
      "Architected and developed both frontend (React) and backend (Spring Boot microservices) for Pakistan's flagship digital identity platform",
      "Integrated 10+ services including Digital ID/Vault, e-Visa, Biometric Verification, Power of Attorney, and Civil Registration into single portal",
      "Implemented ICAO-standard biometric authentication (photo/iris) with LDAP security protocols",
      "Designed microservices architecture enabling seamless service integration while maintaining strict security compliance",
      "Led technical decisions for cross-service data synchronization and citizen identity verification flows",
    ],
    technologies: [
      "Java",
      "Spring Boot",
      "React",
      "Microservices",
      "LDAP",
      "ICAO Biometrics",
      "Oracle",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 22,
    title: "NADRA Self-Service KIOSK",
    subtitle: "Automated Citizen Service Terminal",
    description:
      "Self-service kiosk system for ID renewals, biometric updates and payments with hardware integrations.",
    detailedDescription: [
      "Developed complete kiosk solution using React frontend and Spring Boot backend",
      "Integrated biometric capture devices, ICAO-compliant cameras and POS payment systems",
      "Designed queue-free transaction flows for ID renewals and data updates",
      "Implemented fail-safe mechanisms for offline operation in areas with poor connectivity",
      "Deployed across major Pakistani cities handling 50,000+ monthly transactions",
    ],
    technologies: [
      "React",
      "Spring Boot",
      "Oracle",
      "Biometric Devices",
      "POS Integration",
      "ANTD",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 23,
    title: "NADRA Queue Management System",
    subtitle: "Smart Appointment Booking Platform",
    description:
      "Digital ticketing and appointment system to optimize citizen service center operations.",
    detailedDescription: [
      "Built from scratch using React and Spring Boot microservices architecture",
      "Implemented real-time queue tracking with dashboard analytics for staff",
      "Developed online booking feature reducing wait times by 65%",
      "Integrated with existing NADRA systems for citizen verification",
      "Designed auto-scaling solutions for peak load periods",
    ],
    technologies: [
      "React",
      "Spring Boot",
      "Microservices",
      "WebSockets",
      "Oracle",
      "ChartJS",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 25,
    title: "Decision Support System",
    subtitle: "Operational Analytics Platform",
    description:
      "Data-driven insights system for optimizing NADRA service delivery.",
    detailedDescription: [
      "Built analytics dashboard using React and Spring Boot backend",
      "Developed algorithms to identify processing bottlenecks and resource constraints",
      "Implemented trend analysis for citizen service patterns",
      "Created task assignment optimization models",
      "Reduced average service time by 30% through data-informed changes",
    ],
    technologies: [
      "React",
      "Spring Boot",
      "Oracle",
      "ChartJS",
      "D3.js",
      "Predictive Analytics",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 26,
    title: "Somalian National Identity Verification System",
    description:
      "A web application for verifying identity documents by scanning QR codes, displaying original cardholder data upon verification.",
    detailedDescription: [
      "Designed the application architecture and built the frontend using React JS.",
      "Implemented QR code scanning functionality and real-time redirection to verification pages.",
      "Optimized the application for speed and reduced build size to enhance performance.",
      "Assisted in testing and quality assurance to ensure accurate data verification.",
      "Attended daily Agile meetings to provide updates and address new requirements.",
    ],
    technologies: [
      "React JS",
      "PostgreSQL",
      "JAVA",
      "Spring Boot",
      "JavaScript",
      "Visual Studio",
      "MUI",
      "Agile",
      "JIRA",
      "GitLab",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 1,
    title: "Somalian National Identity System",
    subtitle: "Full-cycle Digital ID and Verification Platform",
    description:
      "A comprehensive digital identity solution for Somalia involving web, desktop, and backend systems for citizen registration, verification, and approval workflows.",
    detailedDescription: [
      "Developed a web and desktop application for citizen registration and identity management, where users register on the web and log in to the desktop app to modify or correct their ID information.",
      "Implemented frontend graphical user interfaces using React JS, including dynamic components, libraries, and forms.",
      "Reviewed and tracked the work of peer developers to ensure code quality and consistency.",
      "Explored strategies to optimize application performance and reduce build size for better efficiency.",
      "Assisted in software testing and quality assurance to ensure a bug-free user experience.",
      "Participated in daily sync-up calls with managers to discuss progress and identify new tasks.",
    ],
    technologies: [
      "React JS",
      ".NET",
      "PostgreSQL",
      "JAVA",
      "Spring Boot",
      "JavaScript",
      "Visual Studio",
      "MUI",
      "JIRA",
      "GitLab",
    ],
    projectType: "fullStack",
    hasDetails: true,
    subProjects: [
      {
        title: "Somalian National Identity Verification System",
        description:
          "A web application for verifying identity documents by scanning QR codes, displaying original cardholder data upon verification.",
        detailedDescription: [
          "Designed the application architecture and built the frontend using React JS.",
          "Implemented QR code scanning functionality and real-time redirection to verification pages.",
          "Optimized the application for speed and reduced build size to enhance performance.",
          "Assisted in testing and quality assurance to ensure accurate data verification.",
          "Attended daily Agile meetings to provide updates and address new requirements.",
        ],
        technologies: [
          "React JS",
          "PostgreSQL",
          "JAVA",
          "Spring Boot",
          "JavaScript",
          "Visual Studio",
          "MUI",
          "Agile",
          "JIRA",
          "GitLab",
        ],
      },
    ],
  },
  {
    id: 2,
    title: "Capital Development Authority Overseas E-Services",
    subtitle: "Property Registration and Payment Platform",
    description:
      "A web application for property registration, selection, and online payment for overseas users.",
    detailedDescription: [
      "Developed a React JS-based web application for property viewing, registration, and online payment processing.",
      "Integrated online payment systems to facilitate seamless transactions for property purchases.",
      "Built dynamic components, libraries, and forms to enhance user interaction.",
      "Implemented new features to improve the user experience and streamline the property selection process.",
      "Assisted in software testing and quality assurance to ensure system reliability.",
    ],
    technologies: [
      "React JS",
      "Oracle",
      "JAVA",
      "Spring Boot",
      "JavaScript",
      "Visual Studio",
      "MUI",
      "Scrum",
      "GitLab",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 3,
    title: "Capital Development Authority Property Management System",
    subtitle: "Property and User Management Platform",
    description:
      "A web application for managing property records, user roles, and generating reports.",
    detailedDescription: [
      "Built a React JS-based system for registering users, assigning roles, and managing properties.",
      "Developed dashboards and reporting features to track application statistics and property data.",
      "Implemented frontend interfaces and dynamic components to enhance usability.",
      "Assisted in testing and quality assurance to ensure accurate data management.",
    ],
    technologies: [
      "React JS",
      "Oracle",
      "JAVA",
      "Spring Boot",
      "JavaScript",
      "Visual Studio",
      "MUI",
      "Scrum",
      "Azure",
      "Swagger",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 4,
    title: "Watani (KSA Govt Service Evaluation)",
    subtitle: "Government Service Feedback Platform",
    description:
      "A Saudi government website for residents and visitors to evaluate public services, helping the government improve based on feedback.",
    detailedDescription: [
      "Developed a Next JS-based web application with multi-language support for broader accessibility.",
      "Optimized application performance and reduced build size for faster loading.",
      "Built dynamic components and libraries to enhance user interaction.",
      "Assisted in testing and quality assurance to ensure accurate data collection.",
      "Participated in daily sync-up calls to discuss progress and new tasks.",
    ],
    technologies: [
      "Next JS",
      "Mongos",
      "Python",
      "JavaScript",
      "Visual Studio",
      "Rest API",
      "Bootstrap",
      "Scrum",
      "GitLab",
      "Swagger",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 5,
    title: "Digital Power of Attorney (Pakistani Government)",
    subtitle: "Online Power of Attorney Issuance and Verification",
    description:
      "A web application for overseas Pakistanis to apply for power of attorney, including biometric verification and document issuance.",
    detailedDescription: [
      "Developed a React JS-based application for user registration, application submission, and biometric verification.",
      "Built REST APIs in Node JS to handle backend processes and data management.",
      "Implemented dynamic components, libraries, and forms to streamline the application process.",
      "Assisted in testing and quality assurance to ensure system accuracy.",
      "Participated in daily meetings to discuss updates and new requirements.",
    ],
    technologies: [
      "React JS",
      "Oracle",
      "Node JS",
      "JavaScript",
      "Visual Studio",
      "Rest API",
      "Prime React",
      "Scrum",
      "GitLab",
      "Swagger",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 6,
    title: "Afghan National Biometric Verification",
    subtitle: "Biometric Data Collection and Verification System",
    description:
      "A web application for collecting and verifying biometric data of Afghan nationals seeking asylum through UNHCR.",
    detailedDescription: [
      "Developed a React JS-based application for data collection, comparison, and result display.",
      "Integrated biometric capture devices with the frontend application for seamless data collection.",
      "Optimized application performance and reduced build size for better efficiency.",
      "Built dynamic components, libraries, and forms to enhance user interaction.",
      "Assisted in testing and quality assurance to ensure data accuracy.",
    ],
    technologies: [
      "React JS",
      "Oracle",
      "Node JS",
      "JavaScript",
      "Visual Studio",
      "ANTD",
      "Scrum",
      "GitLab",
      "Swagger",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 7,
    title: "Sindh Senior Citizen Card",
    subtitle: "Senior Citizen Registration and Management System",
    description:
      "A web application for registering senior citizens in Sindh, with a management system for social welfare departments.",
    detailedDescription: [
      "Developed a React JS-based application for citizen registration and request approval/rejection.",
      "Built dashboards and reporting features for social welfare departments to track statistics.",
      "Optimized application performance and reduced build size for better efficiency.",
      "Implemented dynamic components, libraries, and forms to enhance usability.",
      "Assisted in testing and quality assurance to ensure system reliability.",
    ],
    technologies: [
      "React JS",
      "Oracle",
      "Node JS",
      "JavaScript",
      "Visual Studio",
      "Rest API",
      "Bootstrap",
      "Scrum",
      "GitLab",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 8,
    title: "SHAHADH (Online Certificate Management System)",
    subtitle: "Certificate Design and Management Platform",
    description:
      "A web application for designing, sending, and archiving certificates in an efficient manner.",
    detailedDescription: [
      "Developed an Angular-based application for certificate design and management.",
      "Built dynamic components, libraries, and reactive forms to streamline the certificate creation process.",
      "Wrote unit test cases for every functionality to ensure code reliability.",
      "Assisted in testing and quality assurance to ensure a seamless user experience.",
    ],
    technologies: ["Angular", "PostgreSQL", "Node JS", "Typescript"],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 9,
    title: "Sidra Portal (E-Health Management System)",
    subtitle: "Online Healthcare and Patient Management Platform",
    description:
      "A comprehensive healthcare system for booking appointments, medicine delivery, and patient history management.",
    detailedDescription: [
      "Developed an Angular-based portal for appointment booking, medicine delivery, and patient record management.",
      "Implemented live location tracking for home consultation services.",
      "Built dynamic components, libraries, and reactive forms to enhance usability.",
      "Wrote unit test cases for every functionality to ensure system reliability.",
      "Assisted in testing and quality assurance to ensure accurate data handling.",
    ],
    technologies: ["Angular", "MySQL", "Node JS", "Typescript"],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 10,
    title: "FutureHub (Ecommerce for NGO Donations)",
    subtitle: "Online Donation Platform",
    description:
      "An e-commerce application for donors to purchase products, with proceeds going to needy individuals.",
    detailedDescription: [
      "Developed an Angular-based application with backend processes in Node JS.",
      "Integrated Neonomics API for online payment processing.",
      "Built dynamic components, libraries, and reactive forms to enhance user interaction.",
      "Wrote unit test cases for frontend functionalities to ensure reliability.",
      "Optimized application performance and reduced build size for better efficiency.",
    ],
    technologies: [
      "Angular",
      "PostgreSQL",
      "Node JS",
      "Typescript",
      "Visual Studio",
      "Rest API",
      "Material",
      "Zoho Helix",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 11,
    title: "Inspire (Medical Social Media Platform)",
    subtitle: "Disease-Specific Community and Journal Platform",
    description:
      "A social media platform for users to discuss diseases, join communities, and publish journals.",
    detailedDescription: [
      "Developed an Angular-based platform for patient and doctor interactions.",
      "Built dynamic components, libraries, and reactive forms for user profiles and community features.",
      "Optimized application performance to handle high traffic (1 million users/month).",
      "Wrote unit test cases for frontend functionalities to ensure reliability.",
      "Assisted in testing and quality assurance to ensure seamless user experience.",
    ],
    technologies: [
      "Angular",
      "PostgreSQL",
      "Python",
      "Typescript",
      "Visual Studio",
      "Rest API",
      "Material",
      "Zoho Helix",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 12,
    title: "Pulse (Employee Management System)",
    subtitle: "Internal Employee Tracking and Social Platform",
    description:
      "A web application for tracking employee attendance, tasks, and facilitating social interactions.",
    detailedDescription: [
      "Developed an Angular-based system for attendance tracking, task management, and employee interaction.",
      "Built APIs in Node JS to handle backend processes.",
      "Implemented dynamic components, libraries, and reactive forms for leave applications and skill tracking.",
      "Wrote unit test cases for frontend functionalities to ensure reliability.",
      "Assisted in testing and quality assurance to ensure system accuracy.",
    ],
    technologies: [
      "Angular",
      "PostgreSQL",
      "Node JS",
      "Typescript",
      "Visual Studio",
      "Rest API",
      "Bootstrap",
      "GitHub",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 13,
    title: "TasteBuddy (Online Food Delivery System)",
    subtitle: "Multi-User Restaurant and Food Management Platform",
    description:
      "A large-scale platform for restaurant owners to register menus and offer discounts, with admin approval workflows.",
    detailedDescription: [
      "Developed an Angular-based application for restaurant registration and menu management.",
      "Built dynamic components and features for discount vouchers and admin approvals.",
      "Wrote unit test cases for every functionality to ensure reliability.",
      "Assisted in testing and quality assurance to ensure a seamless user experience.",
      "Participated in daily sync-up calls to discuss progress and new tasks.",
    ],
    technologies: [
      "Angular",
      "NodeJS",
      "Visual Studio",
      "HTML",
      "CSS",
      "JavaScript",
      "TypeScript",
      "Scrum",
      "JIRA",
      "GitHub",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 14,
    title: "Pronto (AI-Powered Promotional Video Tool)",
    subtitle: "Automated Video Creation Platform",
    description:
      "A commercial platform for generating promotional videos with customizable text, accents, and voice-overs.",
    detailedDescription: [
      "Developed an Angular-based application for video creation and media gallery management.",
      "Implemented features for text overlay, accent selection, and voice-over integration.",
      "Wrote unit test cases for every functionality to ensure reliability.",
      "Mentored technical resources and assisted the QA team in automation testing.",
      "Participated in daily sync-up calls to discuss progress and new tasks.",
    ],
    technologies: [
      "Angular",
      "Python",
      "Web API",
      "WebSocket",
      "RESTful API",
      "SQL Server",
      "Swagger",
      "OAuth",
      "JIRA",
      "Scrum",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 15,
    title: "App-Studio (Workflow Automation System)",
    subtitle: "Vendor and Customer Management Platform",
    description:
      "A web application for automating workflows, managing vendors/customers, and integrating live call systems.",
    detailedDescription: [
      "Developed an Angular and AngularJS-based application for workflow automation.",
      "Integrated live call management systems with third-party vendors like Bakster and Ascino.",
      "Wrote unit test cases for every functionality to ensure reliability.",
      "Assisted in testing and quality assurance to ensure seamless operations.",
      "Participated in daily sync-up calls to discuss progress and new tasks.",
    ],
    technologies: [
      "Angular",
      "AngularJS",
      "NodeJS",
      "PostgreSQL",
      "AWS",
      "WebSocket",
      "RESTful API",
      "SQL Server",
      "Swagger",
      "OAuth",
      "JIRA",
      "Prime NG",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 16,
    title: "Baskt (Ecommerce Grocery Store)",
    subtitle: "Online Grocery Shopping Platform",
    description:
      "An e-commerce web application for grocery stores, allowing vendors to register and offer promotions.",
    detailedDescription: [
      "Revamped the application from AngularJS to Angular 2+ for improved performance.",
      "Developed dynamic components, services, and reactive forms for vendor and product management.",
      "Wrote unit test cases for every functionality to ensure reliability.",
      "Optimized performance and usability through code improvements and automation.",
      "Added new features and fixed bugs to enhance the user experience.",
    ],
    technologies: [
      "Angular",
      "AngularJS",
      "NodeJS",
      "Visual Studio",
      "HTML",
      "CSS",
      "JavaScript",
      "TypeScript",
      "Scrum",
      "JIRA",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 17,
    title: "CAFOO (Event Management and Food Delivery)",
    subtitle: "Custom Event and Menu Planning Platform",
    description:
      "A web application for investors to register restaurants/event companies and customers to create custom events/menus.",
    detailedDescription: [
      "Developed an Angular-based application for event planning and menu customization.",
      "Built dynamic components and features for vendor registration and customer bookings.",
      "Wrote unit test cases for every functionality to ensure reliability.",
      "Assisted in testing and quality assurance to ensure seamless operations.",
      "Participated in daily sync-up calls to discuss progress and new tasks.",
    ],
    technologies: [
      "Angular",
      "NodeJS",
      "Visual Studio",
      "HTML",
      "CSS",
      "JavaScript",
      "TypeScript",
      "Scrum",
      "JIRA",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 18,
    title: "CurveBeamAI (Medical AI Tool)",
    subtitle: "Bone Segmentation and 3D Analysis Platform",
    description:
      "An AI-powered web application for orthopedic surgeons to upload images, analyze bone structures, and view 3D-based measurements.",
    detailedDescription: [
      "Developed an Angular-based frontend for image uploads and result visualization.",
      "Built APIs in Node JS to handle backend processes and data management.",
      "Wrote unit test cases for every functionality to ensure reliability.",
      "Assisted in testing and quality assurance to ensure accurate medical analysis.",
      "Participated in daily sync-up calls to discuss progress and new tasks.",
    ],
    technologies: [
      "Angular",
      "NodeJS",
      "Visual Studio",
      "HTML",
      "CSS",
      "JavaScript",
      "TypeScript",
      "Scrum",
      "JIRA",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 19,
    title: "Downak (Hospital Automation System)",
    subtitle: "Patient Record and Appointment Management Platform",
    description:
      "A healthcare system for hospitals to manage patient records, appointments, and staff performance.",
    detailedDescription: [
      "Developed an Angular-based application for patient record management and appointment scheduling.",
      "Built dashboards and reporting features for hospital staff performance monitoring.",
      "Wrote APIs in Node JS to handle backend processes.",
      "Assisted in testing and quality assurance to ensure system accuracy.",
      "Participated in daily sync-up calls to discuss progress and new tasks.",
    ],
    technologies: [
      "Angular",
      "NodeJS",
      "Visual Studio",
      "HTML",
      "CSS",
      "JavaScript",
      "TypeScript",
      "Scrum",
      "JIRA",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 20,
    title: "Energi Bizz (Energy Commerce Platform)",
    subtitle: "E-Commerce Solution for Oil and Gas Sector",
    description:
      "A web application for energy commerce, enabling project tracking, revenue analysis, and trend visualization.",
    detailedDescription: [
      "Developed an Angular-based application for project management and revenue tracking.",
      "Built dashboards for senior management to analyze trends and project statuses.",
      "Wrote unit test cases for every functionality to ensure reliability.",
      "Assisted in testing and quality assurance to ensure seamless operations.",
      "Participated in daily sync-up calls to discuss progress and new tasks.",
    ],
    technologies: [
      "Angular",
      "NodeJS",
      "Visual Studio",
      "HTML",
      "CSS",
      "JavaScript",
      "TypeScript",
      "Scrum",
      "JIRA",
    ],
    projectType: "fullStack",
    hasDetails: true,
  },
  {
    id: 26,
    title: "SASO KSA Heavy Machinery Marketplace",
    subtitle: "Government-Backed Equipment Leasing & Trading Platform",
    description:
      "A multi-language Angular platform for leasing, buying, and selling industrial machinery with multi-level approval workflows.",
    detailedDescription: [
      "Developed the frontend architecture using Angular and Angular Material for a responsive, government-grade user interface",
      "Implemented complex multi-step approval workflows with 'send back' functionality for application reviews",
      "Built bilingual support (English/Arabic) with RTL layout capabilities using Strapi CMS for content management",
      "Created machinery listing modules with detailed specification templates and media galleries",
      "Integrated RESTful APIs for seamless data exchange with backend systems",
      "Developed internal admin modules for managing approvals, user roles, and equipment verification",
      "Wrote comprehensive unit tests using Jasmine/Karma to ensure 90%+ test coverage",
      "Optimized performance for handling large equipment catalogs with lazy loading and virtual scrolling",
    ],
    technologies: [
      "Angular",
      "Angular Material",
      "Strapi CMS",
      "RESTful APIs",
      "Jasmine",
      "Karma",
      "RxJS",
      "i18n",
      "RTL Support",
    ],
    projectType: "frontend",
    hasDetails: true,
  },
];
